// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"styles_sectionWrapper__DCPVh"};